// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileUnknownOutlinedSvg from "@fishx/icons-svg/es/asn/FileUnknownOutlined";
import FishxIcon from '../components/FishxIcon';

var FileUnknownOutlined = function FileUnknownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileUnknownOutlinedSvg
  }));
};

FileUnknownOutlined.displayName = 'FileUnknownOutlined';
export default React.forwardRef(FileUnknownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileUnknownOutlined.js
// module id = 2751
// module chunks = 0